import React from 'react'
import type { PostSummary } from '../../types'
import { PostCard } from './PostCard'
import { LoadingSpinner } from '../ui/LoadingSpinner'

interface PostListProps {
  posts: PostSummary[]
  loading?: boolean
  emptyMessage?: string
}

export const PostList: React.FC<PostListProps> = ({
  posts,
  loading = false,
  emptyMessage = 'No posts found.',
}) => {
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '48px 0',
        }}
      >
        <LoadingSpinner />
      </div>
    )
  }

  if (posts.length === 0) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '48px 0',
          color: 'var(--text-secondary)',
          fontFamily: "'JetBrains Mono', 'Courier New', monospace",
          fontSize: '0.9rem',
        }}
      >
        <div style={{ color: 'var(--accent-amber)', marginBottom: '8px' }}>
          {'>_ '}
        </div>
        <div>{emptyMessage}</div>
      </div>
    )
  }

  return (
    <>
      <style>{`
        .post-list-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }
        @media (min-width: 768px) {
          .post-list-grid {
            grid-template-columns: repeat(auto-fill, minmax(480px, 1fr));
          }
        }
      `}</style>
      <div className="post-list-grid">
        {posts.map((post) => (
          <PostCard key={post.id} post={post} />
        ))}
      </div>
    </>
  )
}
